import __request__ from "routing/request";
export function all(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.forwarder/forwarder/inputstates", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function allForForwarder(forwarderId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.forwarder/forwarder/inputstates/forwarder/${forwarderId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function forForwarderAndInput(forwarderId, inputId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.forwarder/forwarder/inputstates/forwarder/${forwarderId}/input/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function startInput(forwarderId, inputId, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.forwarder/forwarder/inputstates/forwarder/${forwarderId}/input/${inputId}/requested_state/start`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function stopInput(forwarderId, inputId, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.forwarder/forwarder/inputstates/forwarder/${forwarderId}/input/${inputId}/requested_state/stop`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
